// @utilities
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
import { setConfig, getLanguage } from 'core/i18n';
// @constants
const actionTypes = require('constants/actionTypes');

const requestTranslationsStart = () => ({
    type: actionTypes.TRANSLATIONS_FETCH_REQUEST,
});

const requestTranslationsSuccess = translations => ({
    type: actionTypes.TRANSLATIONS_REQUEST_SUCCESS,
    translations,
});

const requestTranslationsFailure = () => ({
    type: actionTypes.TRANSLATIONS_REQUEST_FAILURE,
});

const requestUrlTranslations = type => {
    return Api.get(apiURLBuilder.getURL(`get${type}TranslationsURL`, { language: getLanguage }))
        .then(response => ({ response, error: false }))
        .catch(response => ({ response, error: true }));
};

const requestTranslationsOnboarding = url => {
    return Api.get(url)
        .then(response => ({ response, error: false }))
        .catch(response => ({ response, error: true }));
};

const requestTranslations = () => {
    const requestTrans = ['ONB', 'SHARED'];
    let jsonTranslations = {};
    return async dispatch => {
        dispatch(requestTranslationsStart());

        for (let i = 0; i < requestTrans.length; i++) {
            const response = await requestUrlTranslations(requestTrans[i]);
            if (!response.error && response.response && response.response.body && response.response.body.url) {
                const urlRequest = response.response.body.url;
                const translations = await requestTranslationsOnboarding(urlRequest);
                if (!translations.error && translations.response && translations.response.text) {
                    jsonTranslations = { ...jsonTranslations, ...JSON.parse(translations.response.text) };
                }
            }
        }

        if (Object.keys(jsonTranslations).length !== 0) {
            const parseJsonTranslations = Object.entries(jsonTranslations).reduce((accum, [key, value]) => {
                let newKey = key.replace(/"/g, '');
                return { ...accum, [newKey]: value };
            }, {});

            setConfig(parseJsonTranslations);
            dispatch(requestTranslationsSuccess(parseJsonTranslations));
        } else {
            dispatch(requestTranslationsFailure());
        }
    };
};

export default {
    requestTranslations,
};
